const RotateHandler = {
  data: [],
  rotate: 0,

  doRotate() {
    let result = [];
    switch (this.rotate) {
      case 1:
        result = this.rotate90();
        break;
      case 2:
        result = this.rotate180();
        break;
      case 3:
        result = this.rotate270();
        break;
      default:
        result = this.data;
        break;
    }
    return result;
  },
  // 將二維陣列旋轉 90 度
  rotate90() {
    const newData = [];
    let len = this.getRowLength();
    for (let i = 0; i < len; i++) {
      newData[i] = [];
      for (let j = this.data.length - 1; j >= 0; j--) {
        newData[i].push(this.data[j][i] || null);
      }
    }

    return newData;
  },

  // 將二維陣列旋轉 180 度
  rotate180() {
    const newData = [];
    let len = this.getRowLength();
    for (let i = this.data.length - 1; i >= 0; i--) {
      // this.data[i].reverse()
      newData.push(this.data[i].reverse());
    }
    return newData;
  },
  // 將二維陣列旋轉 270 度
  rotate270() {
    const newData = [];
    let len = this.getRowLength();
    for (let i = len - 1; i >= 0; i--) {
      newData[i] = [];
      for (let j = 0; j < this.data.length; j++) {
        newData[i].push(this.data[j][i] || null);
      }
    }
    newData.reverse();
    return newData;
  },

  getRowLength(data) {
    return (data || this.data).reduce((accr, v) => {
      if (v.length > accr) accr = v.length;
      return accr;
    }, 0);
  },
  // 設置初始數據
  setData(inputData, rotate) {
    // console.log("[rotateHandler] setData")
    let len = this.getRowLength(inputData);
    this.data = inputData.reduce((accr, row) => {
      let r = [];
      for (let i = 0; i < len; i++) {
        r.push(row[i] || null);
      }
      accr.push(r);
      return accr;
    }, []);
    this.rotate = ((rotate % 4) + 4) % 4;
  },

  // 取得目前的數據
  getData() {
    return this.data;
  }
};

export default RotateHandler;
